import { Component } from 'vue-property-decorator';

import MenuItens from '@/components/MenuItens/MenuItens.vue';
import Footer from '@/components/Layout/FooterLogin.vue';

@Component({
  components: {
    MenuItens,
    Footer
  },
})

export default class SidebarComponent {
  data() {
    return {
      open: true,
      overlay: false,
      fullheight: true,
      fullwidth: false,
      right: false
    };
  }

};